<template>
  <div class="setField">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      class="closeBtn"
      @click="closeBtn"
    >
      <g
        id="그룹_20400"
        data-name="그룹 20400"
        transform="translate(-1865 -25)"
      >
        <rect
          id="사각형_25550"
          data-name="사각형 25550"
          width="30"
          height="30"
          transform="translate(1865 25)"
          fill="none"
        />
        <g
          id="그룹_19204"
          data-name="그룹 19204"
          transform="translate(1869.703 30)"
        >
          <line
            id="선_81"
            data-name="선 81"
            x1="20"
            y2="20"
            transform="translate(0.297)"
            fill="none"
            stroke="#fff"
            stroke-linecap="round"
            stroke-width="2"
          />
          <line
            id="선_82"
            data-name="선 82"
            x1="20"
            y1="20"
            transform="translate(0.297)"
            fill="none"
            stroke="#fff"
            stroke-linecap="round"
            stroke-width="2"
          />
        </g>
      </g>
    </svg>

    <div class="popup" v-if="popup">
      <div class="white-bg">
        <h2>활동 분야 건의</h2>
        <p>
          추가되었으면 하는 분야가 있다면 적어주세요.<br />검토 후
          반영하겠습니다.
        </p>
        <input type="text" v-model="suggest" placeholder="분야입력" />
        <div class="popupBtns">
          <div @click="dosuggest">제출</div>
          <div @click="suggestCancel">취소</div>
        </div>
      </div>
    </div>
    <div class="wrap">
      <h2>활동 분야 선택</h2>
      <p>
        본인이 활동하는 분야를 선택해주세요.<br />추천할때 도움이 된답니다~<br /><span
          >( 복수 선택 가능 )</span
        >
      </p>
      <div class="music">
        <div class="selectHeader">
          <svg
            id="그룹_20665"
            data-name="그룹 20665"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            width="24"
            height="24"
            viewBox="0 0 24 24"
          >
            <defs>
              <clipPath id="clip-path">
                <rect
                  id="사각형_25647"
                  data-name="사각형 25647"
                  width="24"
                  height="24"
                  fill="none"
                />
              </clipPath>
            </defs>
            <g
              id="그룹_20664"
              data-name="그룹 20664"
              clip-path="url(#clip-path)"
            >
              <path
                id="패스_8232"
                data-name="패스 8232"
                d="M20,1a3,3,0,0,1,3,3V20a3,3,0,0,1-3,3H4a3,3,0,0,1-3-3V4A3,3,0,0,1,4,1Zm0-1H4A4,4,0,0,0,0,4V20a4,4,0,0,0,4,4H20a4,4,0,0,0,4-4V4a4,4,0,0,0-4-4"
                fill="#dbdbdb"
              />
              <path
                id="패스_8233"
                data-name="패스 8233"
                d="M6,20.5A2.5,2.5,0,1,1,8.5,18,2.5,2.5,0,0,1,6,20.5"
                fill="#8ca0ef"
              />
              <path
                id="패스_8234"
                data-name="패스 8234"
                d="M6,16a2,2,0,1,1-2,2,2,2,0,0,1,2-2m0-1a3,3,0,1,0,3,3,3,3,0,0,0-3-3"
                fill="#8ca0ef"
              />
              <path
                id="패스_8235"
                data-name="패스 8235"
                d="M16,18.5A2.5,2.5,0,1,1,18.5,16,2.5,2.5,0,0,1,16,18.5"
                fill="#8ca0ef"
              />
              <path
                id="패스_8236"
                data-name="패스 8236"
                d="M16,14a2,2,0,1,1-2,2,2,2,0,0,1,2-2m0-1a3,3,0,1,0,3,3,3,3,0,0,0-3-3"
                fill="#8ca0ef"
              />
              <path
                id="패스_8237"
                data-name="패스 8237"
                d="M8,18V7.231L18,4V15.846"
                fill="none"
                stroke="#8ca0ef"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
              />
            </g>
          </svg>
          <h4>음악</h4>
        </div>
        <div class="selectBox">
          <div>
            <input
              type="checkbox"
              v-model="fieldData.field.music"
              value="보컬"
              id="music_vocal"
            />
            <label for="music_vocal"></label>
          </div>
          <div>
            <input
              type="checkbox"
              v-model="fieldData.field.music"
              value="기타"
              id="music_guitar"
            />
            <label for="music_guitar"></label>
          </div>
          <div>
            <input
              type="checkbox"
              v-model="fieldData.field.music"
              value="베이스"
              id="music_bass"
            />
            <label for="music_bass"></label>
          </div>
          <div>
            <input
              type="checkbox"
              v-model="fieldData.field.music"
              value="건반"
              id="music_keyboard"
            />
            <label for="music_keyboard"></label>
          </div>
          <div>
            <input
              type="checkbox"
              v-model="fieldData.field.music"
              value="드럼"
              id="music_drum"
            />
            <label for="music_drum"></label>
          </div>
          <div>
            <input
              type="checkbox"
              v-model="fieldData.field.music"
              value="랩"
              id="music_rap"
            />
            <label for="music_rap"></label>
          </div>
          <div>
            <input
              type="checkbox"
              v-model="fieldData.field.music"
              value="싱어송라이터"
              id="music_singsong"
            />
            <label for="music_singsong"></label>
          </div>
          <div>
            <input
              type="checkbox"
              v-model="fieldData.field.music"
              value="작곡"
              id="music_compose"
            />
            <label for="music_compose"></label>
          </div>
          <div>
            <input
              type="checkbox"
              v-model="fieldData.field.music"
              value="편곡"
              id="music_arrange"
            />
            <label for="music_arrange"></label>
          </div>
          <div>
            <input
              type="checkbox"
              v-model="fieldData.field.music"
              value="작사"
              id="music_lyrics"
            />
            <label for="music_lyrics"></label>
          </div>
          <div>
            <input
              type="checkbox"
              v-model="fieldData.field.music"
              value="비트메이커"
              id="music_beatmaker"
            />
            <label for="music_beatmaker"></label>
          </div>
          <div>
            <input
              type="checkbox"
              v-model="fieldData.field.music"
              value="탑라이너"
              id="music_topliner"
            />
            <label for="music_topliner"></label>
          </div>
          <div id="marginNone">
            <input
              type="checkbox"
              v-model="fieldData.field.music"
              value="클래식"
              id="music_classic"
            />
            <label for="music_classic"></label>
          </div>
          <div id="marginNone">
            <input
              type="checkbox"
              v-model="fieldData.field.music"
              value="녹음"
              id="music_recording"
            />
            <label for="music_recording"></label>
          </div>
          <div id="marginNone">
            <input
              type="checkbox"
              v-model="fieldData.field.music"
              value="믹싱"
              id="music_mixing"
            />
            <label for="music_mixing"></label>
          </div>
        </div>
      </div>
      <div class="video">
        <div class="selectHeader">
          <svg
            id="그룹_20668"
            data-name="그룹 20668"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            width="24"
            height="24"
            viewBox="0 0 24 24"
          >
            <defs>
              <clipPath id="clip-path">
                <rect
                  id="사각형_25649"
                  data-name="사각형 25649"
                  width="24"
                  height="24"
                  fill="none"
                />
              </clipPath>
            </defs>
            <g
              id="그룹_20667"
              data-name="그룹 20667"
              clip-path="url(#clip-path)"
            >
              <path
                id="패스_8238"
                data-name="패스 8238"
                d="M20,1a3,3,0,0,1,3,3V20a3,3,0,0,1-3,3H4a3,3,0,0,1-3-3V4A3,3,0,0,1,4,1Zm0-1H4A4,4,0,0,0,0,4V20a4,4,0,0,0,4,4H20a4,4,0,0,0,4-4V4a4,4,0,0,0-4-4"
                fill="#dbdbdb"
              />
              <rect
                id="사각형_25648"
                data-name="사각형 25648"
                width="12"
                height="7"
                rx="0.5"
                transform="translate(4.5 8.5)"
                fill="#8ca0ef"
              />
              <path
                id="패스_8239"
                data-name="패스 8239"
                d="M16,15H5V9H16Zm0-7H5A1,1,0,0,0,4,9v6a1,1,0,0,0,1,1H16a1,1,0,0,0,1-1V9a1,1,0,0,0-1-1"
                fill="#8ca0ef"
              />
              <path
                id="패스_8240"
                data-name="패스 8240"
                d="M20,9l-3,3,3,3Z"
                fill="#8ca0ef"
              />
              <path
                id="패스_8241"
                data-name="패스 8241"
                d="M20,9l-3,3,3,3Z"
                fill="none"
                stroke="#8ca0ef"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1"
              />
            </g>
          </svg>

          <h4>영상</h4>
        </div>
        <div class="selectBox">
          <div>
            <input
              type="checkbox"
              v-model="fieldData.field.video"
              value="촬영"
              id="video_filming"
            />
            <label for="video_filming"></label>
          </div>
          <div>
            <input
              type="checkbox"
              v-model="fieldData.field.video"
              value="조명"
              id="video_lighting"
            />
            <label for="video_lighting"></label>
          </div>
          <div>
            <input
              type="checkbox"
              v-model="fieldData.field.video"
              value="기획"
              id="video_producer"
            />
            <label for="video_producer"></label>
          </div>
          <div>
            <input
              type="checkbox"
              v-model="fieldData.field.video"
              value="제작"
              id="video_making"
            />
            <label for="video_making"></label>
          </div>
          <div>
            <input
              type="checkbox"
              v-model="fieldData.field.video"
              value="미술"
              id="video_filmart"
            />
            <label for="video_filmart"></label>
          </div>
          <div>
            <input
              type="checkbox"
              v-model="fieldData.field.video"
              value="사운드"
              id="video_filmsound"
            />
            <label for="video_filmsound"></label>
          </div>
          <div>
            <input
              type="checkbox"
              v-model="fieldData.field.video"
              value="연출"
              id="video_directing"
            />
            <label for="video_directing"></label>
          </div>
          <div>
            <input
              type="checkbox"
              v-model="fieldData.field.video"
              value="편집"
              id="video_edit"
            />
            <label for="video_edit"></label>
          </div>
          <div>
            <input
              type="checkbox"
              v-model="fieldData.field.video"
              value="뮤직비디오"
              id="video_mvideo"
            />
            <label for="video_mvideo"></label>
          </div>
          <div id="marginNone">
            <input
              type="checkbox"
              v-model="fieldData.field.video"
              value="드라마"
              id="video_drama"
            />
            <label for="video_drama"></label>
          </div>
          <div id="marginNone">
            <input
              type="checkbox"
              v-model="fieldData.field.video"
              value="광고"
              id="video_advertise"
            />
            <label for="video_advertise"></label>
          </div>
          <div id="marginNone">
            <input
              type="checkbox"
              v-model="fieldData.field.video"
              value="영화"
              id="video_movie"
            />
            <label for="video_movie"></label>
          </div>
        </div>
      </div>
      <div class="photo">
        <div class="selectHeader">
          <svg
            id="그룹_20670"
            data-name="그룹 20670"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            width="24"
            height="24"
            viewBox="0 0 24 24"
          >
            <defs>
              <clipPath id="clip-path">
                <rect
                  id="사각형_25650"
                  data-name="사각형 25650"
                  width="24"
                  height="24"
                  fill="none"
                />
              </clipPath>
            </defs>
            <g
              id="그룹_20669"
              data-name="그룹 20669"
              clip-path="url(#clip-path)"
            >
              <path
                id="패스_8242"
                data-name="패스 8242"
                d="M20,1a3,3,0,0,1,3,3V20a3,3,0,0,1-3,3H4a3,3,0,0,1-3-3V4A3,3,0,0,1,4,1Zm0-1H4A4,4,0,0,0,0,4V20a4,4,0,0,0,4,4H20a4,4,0,0,0,4-4V4a4,4,0,0,0-4-4"
                fill="#dbdbdb"
              />
              <path
                id="패스_8243"
                data-name="패스 8243"
                d="M19.559,19h-14V5h14Zm0-15h-14a1,1,0,0,0-1,1V19a1,1,0,0,0,1,1h14a1,1,0,0,0,1-1V5a1,1,0,0,0-1-1"
                fill="#8ca0ef"
              />
              <path
                id="패스_8244"
                data-name="패스 8244"
                d="M13.559,9.5a1.5,1.5,0,1,1-1.5-1.5,1.5,1.5,0,0,1,1.5,1.5"
                fill="#8ca0ef"
              />
              <path
                id="패스_8245"
                data-name="패스 8245"
                d="M19.559,14v5h-14V17L7.9,13.1a1,1,0,0,1,1.565-.192L13.059,16.5l2.831-4.448a1,1,0,0,1,1.55-.171Z"
                fill="#8ca0ef"
              />
            </g>
          </svg>

          <h4>사진</h4>
        </div>
        <div class="selectBox">
          <div>
            <input
              type="checkbox"
              v-model="fieldData.field.photography"
              value="풍경"
              id="photo_scenephoto"
            />
            <label for="photo_scenephoto"></label>
          </div>
          <div>
            <input
              type="checkbox"
              v-model="fieldData.field.photography"
              value="인물"
              id="photo_portrait"
            />
            <label for="photo_portrait"></label>
          </div>
          <div>
            <input
              type="checkbox"
              v-model="fieldData.field.photography"
              value="제품"
              id="photo_product"
            />
            <label for="photo_product"></label>
          </div>
          <div>
            <input
              type="checkbox"
              v-model="fieldData.field.photography"
              value="상업"
              id="photo_commercial"
            />
            <label for="photo_commercial"></label>
          </div>
          <div>
            <input
              type="checkbox"
              v-model="fieldData.field.photography"
              value="뷰티"
              id="photo_beauty"
            />
            <label for="photo_beauty"></label>
          </div>
          <div>
            <input
              type="checkbox"
              v-model="fieldData.field.photography"
              value="프로필"
              id="photo_profile"
            />
            <label for="photo_profile"></label>
          </div>
          <div id="marginNone">
            <input
              type="checkbox"
              v-model="fieldData.field.photography"
              value="스냅"
              id="photo_snap"
            />
            <label for="photo_snap"></label>
          </div>
        </div>
      </div>
      <div class="design">
        <div class="selectHeader">
          <svg
            id="그룹_20676"
            data-name="그룹 20676"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            width="24"
            height="24"
            viewBox="0 0 24 24"
          >
            <defs>
              <clipPath id="clip-path">
                <rect
                  id="사각형_25653"
                  data-name="사각형 25653"
                  width="24"
                  height="24"
                  fill="none"
                />
              </clipPath>
              <clipPath id="clip-path-2">
                <rect
                  id="사각형_25652"
                  data-name="사각형 25652"
                  width="11.484"
                  height="15.504"
                  transform="translate(10.115 5.557)"
                  fill="none"
                />
              </clipPath>
            </defs>
            <g
              id="그룹_20675"
              data-name="그룹 20675"
              clip-path="url(#clip-path)"
            >
              <path
                id="패스_8246"
                data-name="패스 8246"
                d="M20,1a3,3,0,0,1,3,3V20a3,3,0,0,1-3,3H4a3,3,0,0,1-3-3V4A3,3,0,0,1,4,1Zm0-1H4A4,4,0,0,0,0,4V20a4,4,0,0,0,4,4H20a4,4,0,0,0,4-4V4a4,4,0,0,0-4-4"
                fill="#dbdbdb"
              />
              <path
                id="패스_8247"
                data-name="패스 8247"
                d="M7.864,4.575C4.454,5.968,3.116,10.588,4.509,14a6.633,6.633,0,0,0,.733,1.337.771.771,0,0,0,1.349-.182,2.352,2.352,0,0,1,1.944-1.422,2.3,2.3,0,0,1,2.042.857,2.351,2.351,0,0,1,.346,2.384.771.771,0,0,0,.814,1.091,6.735,6.735,0,0,0,1.469-.413c3.41-1.393,5.771-5.584,4.378-8.994s-6.31-5.474-9.72-4.081"
                fill="#8ca0ef"
              />
              <g id="그룹_20674" data-name="그룹 20674">
                <g
                  id="그룹_20673"
                  data-name="그룹 20673"
                  clip-path="url(#clip-path-2)"
                >
                  <g id="그룹_20672" data-name="그룹 20672">
                    <g
                      id="그룹_20671"
                      data-name="그룹 20671"
                      clip-path="url(#clip-path-2)"
                    >
                      <path
                        id="패스_8248"
                        data-name="패스 8248"
                        d="M21.592,6.182c.186,1.5-3.182,6.606-5.512,9.351a.288.288,0,0,1,.039.352l-1.108,1.576a.268.268,0,0,1-.283.084A4.461,4.461,0,0,1,13.681,19.5,7.683,7.683,0,0,1,10.5,21.049a.319.319,0,0,1-.262-.037l-.047-.048a.379.379,0,0,1-.064-.338l.436-1.933a4.087,4.087,0,0,1,1.894-2.7.31.31,0,0,1-.07-.383L13.5,14.029a.28.28,0,0,1,.272-.086c1.789-3.109,5.466-8.037,6.96-8.362a.7.7,0,0,1,.582.093l.006.012a.7.7,0,0,1,.275.5M15.5,15.093c2.907-3.415,5.575-7.988,5.369-8.809-.835.1-4.3,4.218-6.477,8.03l0,.009L15.5,15.1Zm-.913,1.717.782-1.117-1.441-1.009L13.137,15.8Zm-.6.537a.555.555,0,0,1,.08-.2l-.963-.677a.661.661,0,0,1-.232.185,2.777,2.777,0,0,0-1.525,2.026l-.3,1.355A5.689,5.689,0,0,0,13.2,18.958a3.524,3.524,0,0,0,.792-1.611"
                        fill="#fff"
                      />
                      <path
                        id="패스_8249"
                        data-name="패스 8249"
                        d="M20.871,6.284c.2.82-2.462,5.394-5.369,8.809l0,.009-1.107-.779,0-.009c2.175-3.812,5.641-7.934,6.477-8.03"
                        fill="#8ca0ef"
                      />
                      <path
                        id="패스_8250"
                        data-name="패스 8250"
                        d="M15.371,15.693l-.782,1.117L13.138,15.8l.791-1.114Z"
                        fill="#8ca0ef"
                      />
                      <path
                        id="패스_8251"
                        data-name="패스 8251"
                        d="M14.074,17.142a.539.539,0,0,0-.08.2,3.548,3.548,0,0,1-.792,1.611,5.7,5.7,0,0,1-2.152,1.073l.3-1.355a2.78,2.78,0,0,1,1.526-2.026.67.67,0,0,0,.232-.185Z"
                        fill="#8ca0ef"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <path
                id="패스_8252"
                data-name="패스 8252"
                d="M6,10.193a.5.5,0,1,1,.5-.5.5.5,0,0,1-.5.5"
                fill="#fff"
              />
              <path
                id="패스_8253"
                data-name="패스 8253"
                d="M6,8.693a1,1,0,1,0,1,1,1,1,0,0,0-1-1"
                fill="#fff"
              />
              <path
                id="패스_8254"
                data-name="패스 8254"
                d="M8.646,7.919a.5.5,0,1,1,.5-.5.5.5,0,0,1-.5.5"
                fill="#fff"
              />
              <path
                id="패스_8255"
                data-name="패스 8255"
                d="M8.647,6.419a1,1,0,1,0,1,1,1,1,0,0,0-1-1"
                fill="#fff"
              />
              <path
                id="패스_8256"
                data-name="패스 8256"
                d="M12,7.054a.5.5,0,1,1,.5-.5.5.5,0,0,1-.5.5"
                fill="#fff"
              />
              <path
                id="패스_8257"
                data-name="패스 8257"
                d="M12,5.554a1,1,0,1,0,1,1,1,1,0,0,0-1-1"
                fill="#fff"
              />
              <path
                id="패스_8258"
                data-name="패스 8258"
                d="M14.389,9.919a.5.5,0,1,1,.5-.5.5.5,0,0,1-.5.5"
                fill="#fff"
              />
              <path
                id="패스_8259"
                data-name="패스 8259"
                d="M14.389,8.419a1,1,0,1,0,1,1,1,1,0,0,0-1-1"
                fill="#fff"
              />
              <path
                id="패스_8260"
                data-name="패스 8260"
                d="M10.239,12.4a.5.5,0,1,1,.5-.5.5.5,0,0,1-.5.5"
                fill="#fff"
              />
              <path
                id="패스_8261"
                data-name="패스 8261"
                d="M10.239,10.9a1,1,0,1,0,1,1,1,1,0,0,0-1-1"
                fill="#fff"
              />
            </g>
          </svg>

          <h4>디자인</h4>
        </div>
        <div class="selectBox">
          <div>
            <input
              type="checkbox"
              v-model="fieldData.field.design"
              value="디지털 그래픽"
              id="design_digitalgra"
            />
            <label for="design_digitalgra"></label>
          </div>
          <div>
            <input
              type="checkbox"
              v-model="fieldData.field.design"
              value="캐릭터"
              id="design_character"
            />
            <label for="design_character"></label>
          </div>
          <div>
            <input
              type="checkbox"
              v-model="fieldData.field.design"
              value="3D 아트"
              id="design_modelingart"
            />
            <label for="design_modelingart"></label>
          </div>
          <div>
            <input
              type="checkbox"
              v-model="fieldData.field.design"
              value="일러스트레이션"
              id="design_illustraion"
            />
            <label for="design_illustraion"></label>
          </div>
          <div>
            <input
              type="checkbox"
              v-model="fieldData.field.design"
              value="타이포그래피"
              id="design_typo"
            />
            <label for="design_typo"></label>
          </div>
          <div>
            <input
              type="checkbox"
              v-model="fieldData.field.design"
              value="제품/패키지"
              id="design_productd"
            />
            <label for="design_productd"></label>
          </div>
          <div>
            <input
              type="checkbox"
              v-model="fieldData.field.design"
              value="UI/UX"
              id="design_uiux"
            />
            <label for="design_uiux"></label>
          </div>
          <div>
            <input
              type="checkbox"
              v-model="fieldData.field.design"
              value="파인아트"
              id="design_fineart"
            />
            <label for="design_fineart"></label>
          </div>
          <div id="marginNone">
            <input
              type="checkbox"
              v-model="fieldData.field.design"
              value="디지털 아트"
              id="design_digitalart"
            />
            <label for="design_digitalart"></label>
          </div>
        </div>
      </div>
      <div class="specialist">
        <div class="selectHeader">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
          >
            <g
              id="그룹_20666"
              data-name="그룹 20666"
              transform="translate(-740 -1401)"
            >
              <g
                id="사각형_25646"
                data-name="사각형 25646"
                transform="translate(740 1401)"
                fill="#fff"
                stroke="#dbdbdb"
                stroke-width="1"
              >
                <rect width="24" height="24" rx="4" stroke="none" />
                <rect
                  x="0.5"
                  y="0.5"
                  width="23"
                  height="23"
                  rx="3.5"
                  fill="none"
                />
              </g>
              <rect
                id="사각형_23996"
                data-name="사각형 23996"
                width="18"
                height="18"
                transform="translate(743.001 1404)"
                fill="#fff"
              />
              <path
                id="패스_7696"
                data-name="패스 7696"
                d="M336.394-159.375a4.363,4.363,0,0,0,4.364-4.364,4.363,4.363,0,0,0-4.364-4.364,4.363,4.363,0,0,0-4.364,4.364A4.363,4.363,0,0,0,336.394-159.375Zm0,2.182c-2.913,0-8.727,1.462-8.727,4.364v2.182h17.455v-2.182C345.122-155.731,339.307-157.193,336.394-157.193Z"
                transform="translate(415.605 1572.375)"
                fill="#8ca0ef"
              />
            </g>
          </svg>
          <h4>스페셜리스트</h4>
        </div>
        <div class="selectBox">
          <div>
            <input
              type="checkbox"
              v-model="fieldData.field.specialist"
              value="연기"
              id="special_act"
            />
            <label for="special_act"></label>
          </div>
          <div>
            <input
              type="checkbox"
              v-model="fieldData.field.specialist"
              value="모델"
              id="special_model"
            />
            <label for="special_model"></label>
          </div>
          <div>
            <input
              type="checkbox"
              v-model="fieldData.field.specialist"
              value="춤"
              id="special_dancer"
            />
            <label for="special_dancer"></label>
          </div>
          <div>
            <input
              type="checkbox"
              v-model="fieldData.field.specialist"
              value="헤어"
              id="special_hair"
            />
            <label for="special_hair"></label>
          </div>
          <div>
            <input
              type="checkbox"
              v-model="fieldData.field.specialist"
              value="메이크업"
              id="special_makeup"
            />
            <label for="special_makeup"></label>
          </div>
          <div>
            <input
              type="checkbox"
              v-model="fieldData.field.specialist"
              value="유튜버"
              id="special_youtuber"
            />
            <label for="special_youtuber"></label>
          </div>
          <div id="marginNone">
            <input
              type="checkbox"
              v-model="fieldData.field.specialist"
              value="스타일리스트"
              id="special_stylist"
            />
            <label for="special_stylist"></label>
          </div>
        </div>
      </div>
      <div class="suggest">
        <span> 활동하시는 분야가 없나요?</span>
        <span class="suggestBtn" @click="suggestPopup">활동 분야 건의</span>
      </div>
      <div class="nextBtn" @click="nextPage">완료</div>
    </div>
  </div>
</template>

<script>
import vClickOutside from "v-click-outside";

export default {
  name: "setField",
  mounted() {
    document.getElementsByTagName("body")[0].style.overflow = "hidden";
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  computed: {
    fieldData() {
      return this.$store.state.userSetup.userInfoSetup;
    },
    API_URL() {
      return this.$store.state.API_URL;
    },
  },
  data() {
    return {
      popup: false,
      suggest: "",
      music: [],
    };
  },
  methods: {
    suggestCancel() {
      this.suggest = "";
      document.getElementsByTagName("body")[0].style.overflow = "scroll";
      this.popup = false;
    },
    suggestPopup() {
      document.getElementsByTagName("body")[0].style.overflow = "hidden";
      this.popup = true;
    },
    nextPage() {
      this.$router.go(-1);
      // this.$store.commit("set_fieldMusic", this.music);
    },
    closeBtn() {
      this.$router.go(-1);
    },
    dosuggest() {
      let loginUg = localStorage.getItem("loginUg");
      if (loginUg == "false") {
        if (this.suggest == "") {
          alert("건의하실 내용을 적어주세요.");
        } else if (this.suggest !== "") {
          let token = JSON.parse(sessionStorage.getItem("token"));
          this.$axios
            .post(
              this.API_URL + "/accounts/report-field",
              {
                userID: token.userID,
                play_field: this.suggest,
              },
              {
                headers: { Authorization: `Bearer ${token.access_token}` },
              }
            )
            .then((res) => {
              if (res.data.status == 200) {
                alert("성공적으로 제출했습니다. 검토 후 반영하겠습니다.");
                this.popup = false;
                this.suggest = "";
              }
            })
            .catch((err) => {
              console.log(err);
            });
        }
      } else if (loginUg == "ture") {
        if (this.suggest == "") {
          alert("건의하실 내용을 적어주세요.");
        } else if (this.suggest !== "") {
          let token = this.$cookie.get("access_token");
          let userID = this.$cookie.get("userID");
          this.$axios
            .post(
              this.API_URL + "/accounts/report-field",
              {
                userID: userID,
                play_field: this.suggest,
              },
              {
                headers: { Authorization: `Bearer ${token}` },
              }
            )
            .then((res) => {
              if (res.data.status == 200) {
                alert("성공적으로 제출했습니다. 검토 후 반영하겠습니다.");
                this.popup = false;
                this.suggest = "";
              }
            })
            .catch((err) => {
              console.log(err);
            });
        }
      }
    },
  },
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
}
.closeBtn {
  cursor: pointer;
  position: fixed;
  top: 40px;
  right: 40px;
}
.setField {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.8);
  z-index: 5;
  overflow: auto;
}
.popup {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.8);
  z-index: 7;
}
.white-bg {
  width: 500px;
  height: 338px;
  padding: 0 58px;
  margin: 305px auto;
  background: #ffffff 0% 0% no-repeat padding-box;
  border-radius: 4px;
  text-align: center;
}
.white-bg h2 {
  padding-top: 40px;
  font: normal normal bold 20px/29px Noto Sans CJK KR;
  letter-spacing: -0.5px;
  color: #8ca0ef;
}
.white-bg p {
  font: normal normal normal 16px/24px Noto Sans CJK KR;
  letter-spacing: -0.4px;
  color: #191919;
  margin: 30px;
}
.white-bg input {
  width: 384px;
  height: 40px;
  outline: none;
  border: 1px solid #dbdbdb;
  border-radius: 4px;
  box-sizing: border-box;
  padding: 10px;
}
.popupBtns {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 40px;
}
.popupBtns div {
  width: 180px;
  height: 40px;
  background: #8ca0ef 0% 0% no-repeat padding-box;
  border-radius: 20px;

  font: normal normal normal 16px/24px Noto Sans CJK KR;
  letter-spacing: -0.4px;
  color: #ffffff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.popupBtns div:last-child {
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #707070;
  color: #707070;
  margin-left: 24px;
}
.wrap {
  width: 500px;
  min-height: 1676px;
  background: #ffffff 0% 0% no-repeat padding-box;
  margin: 110px auto;
  padding: 0 58px;
  margin-bottom: 114px;
  text-align: center;
}
.wrap h2 {
  padding: 40px 0;
  font: normal normal bold 28px/41px Noto Sans CJK KR;
  letter-spacing: -0.7px;
  color: #8ca0ef;
}
.wrap p {
  font: normal normal normal 18px/27px Noto Sans CJK KR;
  letter-spacing: -0.45px;
  color: #191919;
  margin-bottom: 40px;
}
.wrap p > span {
  font: normal normal normal 16px/24px Noto Sans CJK KR;
  letter-spacing: -0.4px;
}
.selectHeader {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 10px;
  padding-bottom: 10px;
}
.selectHeader h4 {
  font: normal normal normal 18px/27px Noto Sans CJK KR;
  letter-spacing: -0.45px;
  color: #191919;
}
.selectHeader svg {
  margin-right: 10px;
}
.selectBox {
  width: 384px;
  padding: 16px;
  display: flex;
  flex-flow: wrap;
  margin-bottom: 30px;
  border: 1px solid #dbdbdb;
  border-radius: 4px;
}
.selectBox div {
  margin-right: 14px;
  height: 30px;
  margin-bottom: 12px;
}
#marginNone {
  margin-bottom: 0px;
}
.wrap input {
  display: none;
}
input + label {
  cursor: pointer;
}
input + label::before {
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #707070;
  border-radius: 15px;
  font: normal normal normal 16px/24px Noto Sans CJK KR;
  letter-spacing: 0px;
  color: #707070;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  transition: 0.2s;
}
input:checked + label::before {
  background: #8ca0ef 0% 0% no-repeat padding-box;
  border: none;
  color: #ffffff;
}
input#music_vocal + label:before {
  content: "보컬";
  width: 90px;
  height: 30px;
}

input#music_guitar + label:before {
  content: "기타";
  width: 90px;
  height: 30px;
}

input#music_bass + label:before {
  content: "베이스";
  width: 104px;
  height: 30px;
}

input#music_keyboard + label:before {
  content: "건반";
  width: 90px;
  height: 30px;
}

input#music_drum + label:before {
  content: "드럼";
  width: 90px;
  height: 30px;
}

input#music_rap + label:before {
  content: "랩";
  width: 76px;
  height: 30px;
}

input#music_singsong + label:before {
  content: "싱어송라이터";
  width: 126px;
  height: 30px;
}

input#music_compose + label:before {
  content: "작곡";
  width: 90px;
  height: 30px;
}

input#music_arrange + label:before {
  content: "편곡";
  width: 90px;
  height: 30px;
}

input#music_lyrics + label:before {
  content: "작사";
  width: 90px;
  height: 30px;
}

input#music_beatmaker + label:before {
  content: "비트메이커";
  width: 114px;
  height: 30px;
}

input#music_topliner + label:before {
  content: "탑라이너";
  width: 100px;
  height: 30px;
}

input#music_classic + label:before {
  content: "클래식";
  width: 104px;
  height: 30px;
}

input#music_recording + label:before {
  content: "녹음";
  width: 90px;
  height: 30px;
}

input#music_mixing + label:before {
  content: "믹싱";
  width: 90px;
  height: 30px;
}
input#video_filming + label:before {
  content: "촬영";
  width: 90px;
  height: 30px;
}
input#video_lighting + label:before {
  content: "조명";
  width: 90px;
  height: 30px;
}
input#video_producer + label:before {
  content: "기획";
  width: 90px;
  height: 30px;
}
input#video_making + label:before {
  content: "제작";
  width: 90px;
  height: 30px;
}
input#video_filmart + label:before {
  content: "미술";
  width: 90px;
  height: 30px;
}
input#video_filmsound + label:before {
  content: "사운드";
  width: 104px;
  height: 30px;
}
input#video_directing + label:before {
  content: "연출";
  width: 90px;
  height: 30px;
}
input#video_edit + label:before {
  content: "편집";
  width: 90px;
  height: 30px;
}
input#video_mvideo + label:before {
  content: "뮤직비디오";
  width: 114px;
  height: 30px;
}
input#video_drama + label:before {
  content: "드라마";
  width: 104px;
  height: 30px;
}
input#video_advertise + label:before {
  content: "광고";
  width: 90px;
  height: 30px;
}
input#video_movie + label:before {
  content: "영화";
  width: 90px;
  height: 30px;
}
input#photo_scenephoto + label:before {
  content: "풍경";
  width: 90px;
  height: 30px;
}
input#photo_portrait + label:before {
  content: "인물";
  width: 90px;
  height: 30px;
}
input#photo_product + label:before {
  content: "제품";
  width: 90px;
  height: 30px;
}
input#photo_commercial + label:before {
  content: "상업";
  width: 90px;
  height: 30px;
}
input#photo_beauty + label:before {
  content: "뷰티";
  width: 90px;
  height: 30px;
}
input#photo_profile + label:before {
  content: "프로필";
  width: 104px;
  height: 30px;
}
input#photo_snap + label:before {
  content: "스냅";
  width: 90px;
  height: 30px;
}
input#design_digitalgra + label:before {
  content: "디지털 그래픽";
  width: 120px;
  height: 30px;
}
input#design_character + label:before {
  content: "캐릭터";
  width: 90px;
  height: 30px;
}
input#design_modelingart + label:before {
  content: "3D 아트";
  width: 90px;
  height: 30px;
}
input#design_illustraion + label:before {
  content: "일러스트레이션";
  width: 140px;
  height: 30px;
}
input#design_typo + label:before {
  content: "타이포그래피";
  width: 120px;
  height: 30px;
}
input#design_productd + label:before {
  content: "제품/패키지";
  width: 120px;
  height: 30px;
}
input#design_uiux + label:before {
  content: "UI/UX";
  width: 85px;
  height: 30px;
}
input#design_fineart + label:before {
  content: "파인아트";
  width: 100px;
  height: 30px;
}
input#design_digitalart + label:before {
  content: "디지털 아트";
  width: 110px;
  height: 30px;
}
input#special_act + label:before {
  content: "연기";
  width: 90px;
  height: 30px;
}
input#special_model + label:before {
  content: "모델";
  width: 90px;
  height: 30px;
}
input#special_dancer + label:before {
  content: "춤";
  width: 76px;
  height: 30px;
}
input#special_hair + label:before {
  content: "헤어";
  width: 90px;
  height: 30px;
}
input#special_makeup + label:before {
  content: "메이크업";
  width: 100px;
  height: 30px;
}
input#special_youtuber + label:before {
  content: "유튜버";
  width: 90px;
  height: 30px;
}
input#special_stylist + label:before {
  content: "스타일리스트";
  width: 126px;
  height: 30px;
}
.suggest {
  padding-top: 10px;
}
.suggest span {
  font: normal normal normal 16px/24px Noto Sans CJK KR;
  letter-spacing: -0.4px;
  color: #707070;
}
.suggestBtn {
  text-decoration: underline;
  cursor: pointer;
  margin-left: 10px;
}
.nextBtn {
  width: 384px;
  height: 40px;
  background: #8ca0ef 0% 0% no-repeat padding-box;
  border-radius: 20px;

  font: normal normal normal 20px/29px Noto Sans CJK KR;
  letter-spacing: -0.5px;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 30px;
  cursor: pointer;
}
</style>
